<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 class="pa-4">
        <FlightSummary />
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
      v-if="loading !== true && total_price !== '0.00'"
      class="payment_info"
    >
      <v-flex xs12>
        <v-card flat class="pa-4">
          <v-card-text>
            <h1 class="primary--text">
              Billing &amp; Payment Information
            </h1>
            <div v-if="user.id !==  null && user.has_prepaid === true">
              <p>
                You currently have prepaid tickets available, which includes a baggage allowance of 50lbs per person and up to 5 days of free parking, based on availability.
              </p>
              <p>
                How would you like to pay for this flight?
              </p>
              <v-layout column class="my-2">
                <v-flex>
                  <v-radio-group v-model="use_prepaid" @change="validatePayment">
                    <v-radio label="Prepaid Tickets" :value="true"></v-radio>
                    <v-radio label="Credit Card / Debit Card" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 v-show="
        user.id === null ||
        user.has_prepaid !== true ||
        form_fields.use_prepaid === false
      ">
        <v-card flat class="px-4">
          <v-card-text>
            <p class="caps warning">All fields are required</p>
						<div class="payment-error" v-if="paymentErrorMsg !== '' && paymentErrorMsg !== null" v-html="paymentErrorMsg"></div>
            <v-container class="mt-3">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <p><strong>Billing Address</strong><br>
                  <em>(must match the billing address of the card being used)</em></p>
                  <v-layout column>
                    <v-flex xs12>
                      <v-select
                        label="Country"
                        :items="countries"
                        item-text="country"
                        item-value="abbr"
                        v-model="country"
                        outline
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="Address Line 1"
                        v-model="street"
                        :rules="[rules.required]"
                        outline
                        @keyup.native="validatePayment"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="Address Line 2 (Optional)"
                        v-model="street2"
                        outline
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        label="City"
                        v-model="city"
                        :rules="[rules.required]"
                        outline
                        @keyup.native="validatePayment"
                      ></v-text-field>
                    </v-flex>
                    <v-flex v-if="country === 'CA'">
                      <v-select
                        label="Province"
                        :items="provinces"
                        item-text="name"
                        item-value="abbr"
                        v-model="province"
                        outline
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex v-else-if="country === 'US'">
                      <v-select
                        label="State"
                        :items="states"
                        item-text="name"
                        item-value="abbr"
                        v-model="province"
                        outline
                        dense
                      ></v-select>
                    </v-flex>
                    <v-flex v-else>
                      <v-text-field
                        label="State/Province"
                        v-model="province"
                        outline
                        dense
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field
                        :label="postal_wording"
                        v-model="postal_code"
                        :rules="[rules.required]"
                        outline
                        @keyup.native="validatePayment"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 class="left_pad_lg">
                  <v-layout column>
                    <p><strong>Credit Card Details</strong><br>
                    <em>(must match the card being used)</em></p>
										<v-flex>
											<v-layout row wrap>
                        <v-flex xs12 sm5>
													<v-text-field
		                        label="First Name"
		                        v-model="cardholder_fn"
		                        :rules="[rules.required]"
		                        outline
		                        @keyup.native="validatePayment"
		                      ></v-text-field>
												</v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm6>
													<v-text-field
		                        label="Last Name"
		                        v-model="cardholder_ln"
		                        :rules="[rules.required]"
		                        outline
		                        @keyup.native="validatePayment"
		                      ></v-text-field>
												</v-flex>
											</v-layout>
										</v-flex>
                    <v-flex>
                      <v-text-field
                        label="Credit Card Number"
                        v-model="number"
                        mask="#### #### #### ####"
                        :rules="[rules.required]"
                        outline
                        @keyup.native="validatePayment"
                      ></v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-layout row wrap>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="Expiry Month (MM)"
                            v-model="mm"
                            mask="##"
                            :rules="[rules.required, rules.month]"
                            outline
                            @keyup.native="validatePayment"
                          ></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm4>
                          <v-text-field
                            label="Expiry Year (YY)"
                            v-model="yy"
                            mask="##"
                            :rules="[rules.required, rules.year]"
                            outline
                            @keyup.native="validatePayment"
                          ></v-text-field>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-flex xs12 sm3>
                          <v-text-field
                            label="CVV"
                            v-model="cvv"
                            mask="####"
                            :rules="[rules.required]"
                            outline
                            @keyup.native="validatePayment"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
										<vue-hcaptcha
											ref="hcaptcha"
											sitekey="6be0a036-ab4a-49ca-a9c4-f67aa8c42260"
											@verify="onHCVerify"
											@expired="onHCExpired"
											@error="onHCError"
											@rendered="onHCRendered"
											></vue-hcaptcha>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import Shared from "@/mixins/Shared";
import FlightSummary from "@/components/pages/FlightSummary.vue";
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField",
});

export default {
  name: "PaymentForm",
  mixins: [Shared],
  components: {FlightSummary, VueHcaptcha},
  computed: {
    postal_wording() {
      return (this.country !== "United States") ? "Postal Code" : "Zip Code";
    },
    total_price() {
      return this.line_items.total;
    },
		paymentErrorMsg() {
      console.log('found error',this.paymentError);
			return this.paymentError;
		},
    ...mapFields([
      "paymentError"
    ])
	},
	data() {
    return {
      hcaptchaReady: false
    };
  },
	methods: {
    onHCVerify(token) {
      console.log("Token received:", token);
      this.form_fields.hcaptchaToken = token;
    },
    onHCExpired() {
      this.form_fields.hcaptchaToken = null;
    },
    onHCError() {
      this.form_fields.hcaptchaToken = null;
		},
    onHCRendered() {
      this.hcaptchaReady = true;
      this.runHCaptcha();
    },
		async runHCaptcha() {
      try {
        const res = await this.$refs.hcaptcha.executeAsync();
        if (res && res.response) {
          this.form_fields.hcaptchaToken = res.response;
        }
      } catch (err) {
        console.error("hCaptcha execute failed:", err);
      }
    }
	},
  mounted() {
		this.validatePayment();
		if (this.hcaptchaReady) {
      this.runHCaptcha();
    }
  },
  created() {
    this.validatePayment();
  },
  data: function() {
    return {
      countries: [
        { abbr: "CA", country: "Canada" },
        { abbr: "US", country: "United States" },
        { abbr: "AF", country: "Afghanistan" },
        { abbr: "AL", country: "Albania" },
        { abbr: "DZ", country: "Algeria" },
        { abbr: "AS", country: "American Samoa" },
        { abbr: "AD", country: "Andorra" },
        { abbr: "AO", country: "Angola" },
        { abbr: "AI", country: "Anguilla" },
        { abbr: "AQ", country: "Antarctica" },
        { abbr: "AG", country: "Antigua And Barbuda" },
        { abbr: "AR", country: "Argentina" },
        { abbr: "AM", country: "Armenia" },
        { abbr: "AW", country: "Aruba" },
        { abbr: "AU", country: "Australia" },
        { abbr: "AT", country: "Austria" },
        { abbr: "AZ", country: "Azerbaijan" },
        { abbr: "BS", country: "Bahamas" },
        { abbr: "BH", country: "Bahrain" },
        { abbr: "BD", country: "Bangladesh" },
        { abbr: "BB", country: "Barbados" },
        { abbr: "BY", country: "Belarus" },
        { abbr: "BE", country: "Belgium" },
        { abbr: "BZ", country: "Belize" },
        { abbr: "BJ", country: "Benin" },
        { abbr: "BM", country: "Bermuda" },
        { abbr: "BT", country: "Bhutan" },
        { abbr: "BO", country: "Bolivia" },
        { abbr: "BA", country: "Bosnia And Herzegovina" },
        { abbr: "BW", country: "Botswana" },
        { abbr: "BV", country: "Bouvet Island" },
        { abbr: "BR", country: "Brazil" },
        { abbr: "IO", country: "British Indian Ocean Territory" },
        { abbr: "BN", country: "Brunei Darussalam" },
        { abbr: "BG", country: "Bulgaria" },
        { abbr: "BF", country: "Burkina Faso" },
        { abbr: "BI", country: "Burundi" },
        { abbr: "KH", country: "Cambodia" },
        { abbr: "CM", country: "Cameroon" },
        { abbr: "CV", country: "Cape Verde" },
        { abbr: "KY", country: "Cayman Islands" },
        { abbr: "CF", country: "Central African Republic" },
        { abbr: "TD", country: "Chad" },
        { abbr: "CL", country: "Chile" },
        { abbr: "CN", country: "China" },
        { abbr: "CX", country: "Christmas Island" },
        { abbr: "CC", country: "Cocos (keeling) Islands" },
        { abbr: "CO", country: "Colombia" },
        { abbr: "KM", country: "Comoros" },
        { abbr: "CG", country: "Congo" },
        { abbr: "CK", country: "Cook Islands" },
        { abbr: "CR", country: "Costa Rica" },
        { abbr: "CI", country: "Cote D'ivoire" },
        { abbr: "HR", country: "Croatia (local Name: Hrvatska" },
        { abbr: "CU", country: "Cuba" },
        { abbr: "CY", country: "Cyprus" },
        { abbr: "CZ", country: "Czech Republic" },
        { abbr: "DK", country: "Denmark" },
        { abbr: "DJ", country: "Djibouti" },
        { abbr: "DM", country: "Dominica" },
        { abbr: "DO", country: "Dominican Republic" },
        { abbr: "TL", country: "East Timor" },
        { abbr: "EC", country: "Ecuador" },
        { abbr: "EG", country: "Egypt" },
        { abbr: "SV", country: "El Salvador" },
        { abbr: "GQ", country: "Equatorial Guinea" },
        { abbr: "ER", country: "Eritrea" },
        { abbr: "EE", country: "Estonia" },
        { abbr: "ET", country: "Ethiopia" },
        { abbr: "FK", country: "Falkland Islands (malvinas" },
        { abbr: "FO", country: "Faroe Islands" },
        { abbr: "FJ", country: "Fiji" },
        { abbr: "FI", country: "Finland" },
        { abbr: "FR", country: "France" },
        { abbr: "FX", country: "France, Metropolitan" },
        { abbr: "GF", country: "French Guiana" },
        { abbr: "PF", country: "French Polynesia" },
        { abbr: "TF", country: "French Southern Territories" },
        { abbr: "GA", country: "Gabon" },
        { abbr: "GM", country: "Gambia" },
        { abbr: "GE", country: "Georgia" },
        { abbr: "DE", country: "Germany" },
        { abbr: "GH", country: "Ghana" },
        { abbr: "GI", country: "Gibraltar" },
        { abbr: "GR", country: "Greece" },
        { abbr: "GL", country: "Greenland" },
        { abbr: "GD", country: "Grenada" },
        { abbr: "GP", country: "Guadeloupe" },
        { abbr: "GU", country: "Guam" },
        { abbr: "GT", country: "Guatemala" },
        { abbr: "GN", country: "Guinea" },
        { abbr: "GW", country: "Guinea-bissau" },
        { abbr: "GY", country: "Guyana" },
        { abbr: "HT", country: "Haiti" },
        { abbr: "HM", country: "Heard Island & Mcdonald Islands" },
        { abbr: "HN", country: "Honduras" },
        { abbr: "HK", country: "Hong Kong" },
        { abbr: "HU", country: "Hungary" },
        { abbr: "IS", country: "Iceland" },
        { abbr: "IN", country: "India" },
        { abbr: "ID", country: "Indonesia" },
        { abbr: "IR", country: "Iran, Islamic Republic Of" },
        { abbr: "IQ", country: "Iraq" },
        { abbr: "IE", country: "Ireland" },
        { abbr: "IL", country: "Israel" },
        { abbr: "IT", country: "Italy" },
        { abbr: "JM", country: "Jamaica" },
        { abbr: "JP", country: "Japan" },
        { abbr: "JO", country: "Jordan" },
        { abbr: "KZ", country: "Kazakhstan" },
        { abbr: "KE", country: "Kenya" },
        { abbr: "KI", country: "Kiribati" },
        { abbr: "KP", country: "Korea, Democratic People's Republic Of" },
        { abbr: "KR", country: "Korea, Republic Of" },
        { abbr: "KW", country: "Kuwait" },
        { abbr: "KG", country: "Kyrgyzstan" },
        { abbr: "LA", country: "Lao People's Democratic Republic" },
        { abbr: "LV", country: "Latvia" },
        { abbr: "LB", country: "Lebanon" },
        { abbr: "LS", country: "Lesotho" },
        { abbr: "LR", country: "Liberia" },
        { abbr: "LY", country: "Libyan Arab Jamahiriya" },
        { abbr: "LI", country: "Liechtenstein" },
        { abbr: "LT", country: "Lithuania" },
        { abbr: "LU", country: "Luxembourg" },
        { abbr: "MO", country: "Macau" },
        { abbr: "MK", country: "Macedonia, The Former Yugoslav Republic Of" },
        { abbr: "MG", country: "Madagascar" },
        { abbr: "MW", country: "Malawi" },
        { abbr: "MY", country: "Malaysia" },
        { abbr: "MV", country: "Maldives" },
        { abbr: "ML", country: "Mali" },
        { abbr: "MT", country: "Malta" },
        { abbr: "MH", country: "Marshall Islands" },
        { abbr: "MQ", country: "Martinique" },
        { abbr: "MR", country: "Mauritania" },
        { abbr: "MU", country: "Mauritius" },
        { abbr: "YT", country: "Mayotte" },
        { abbr: "MX", country: "Mexico" },
        { abbr: "FM", country: "Micronesia, Federated States Of" },
        { abbr: "MD", country: "Moldova, Republic Of" },
        { abbr: "MC", country: "Monaco" },
        { abbr: "MN", country: "Mongolia" },
        { abbr: "MS", country: "Montserrat" },
        { abbr: "MA", country: "Morocco" },
        { abbr: "MZ", country: "Mozambique" },
        { abbr: "MM", country: "Myanmar" },
        { abbr: "NA", country: "Namibia" },
        { abbr: "NR", country: "Nauru" },
        { abbr: "NP", country: "Nepal" },
        { abbr: "NL", country: "Netherlands" },
        { abbr: "AN", country: "Netherlands Antilles" },
        { abbr: "NC", country: "New Caledonia" },
        { abbr: "NZ", country: "New Zealand" },
        { abbr: "NI", country: "Nicaragua" },
        { abbr: "NE", country: "Niger" },
        { abbr: "NG", country: "Nigeria" },
        { abbr: "NU", country: "Niue" },
        { abbr: "NF", country: "Norfolk Island" },
        { abbr: "MP", country: "Northern Mariana Islands" },
        { abbr: "NO", country: "Norway" },
        { abbr: "OM", country: "Oman" },
        { abbr: "PK", country: "Pakistan" },
        { abbr: "PW", country: "Palau" },
        { abbr: "PA", country: "Panama" },
        { abbr: "PG", country: "Papua New Guinea" },
        { abbr: "PY", country: "Paraguay" },
        { abbr: "PE", country: "Peru" },
        { abbr: "PH", country: "Philippines" },
        { abbr: "PN", country: "Pitcairn" },
        { abbr: "PL", country: "Poland" },
        { abbr: "PT", country: "Portugal" },
        { abbr: "PR", country: "Puerto Rico" },
        { abbr: "QA", country: "Qatar" },
        { abbr: "RE", country: "Reunion" },
        { abbr: "RO", country: "Romania" },
        { abbr: "RU", country: "Russian Federation" },
        { abbr: "RW", country: "Rwanda" },
        { abbr: "KN", country: "Saint Kitts And Nevis" },
        { abbr: "LC", country: "Saint Lucia" },
        { abbr: "VC", country: "Saint Vincent And The Grenadines" },
        { abbr: "WS", country: "Samoa" },
        { abbr: "SM", country: "San Marino" },
        { abbr: "ST", country: "Sao Tome And Principe" },
        { abbr: "SA", country: "Saudi Arabia" },
        { abbr: "SN", country: "Senegal" },
        { abbr: "RS", country: "Serbia" },
        { abbr: "SC", country: "Seychelles" },
        { abbr: "SL", country: "Sierra Leone" },
        { abbr: "SG", country: "Singapore" },
        { abbr: "SK", country: "Slovakia (slovak Republic" },
        { abbr: "SI", country: "Slovenia" },
        { abbr: "SB", country: "Solomon Islands" },
        { abbr: "SO", country: "Somalia" },
        { abbr: "ZA", country: "South Africa" },
        { abbr: "ES", country: "Spain" },
        { abbr: "LK", country: "Sri Lanka" },
        { abbr: "SH", country: "Saint Helena" },
        { abbr: "PM", country: "Saint Pierre And Miquelon" },
        { abbr: "SD", country: "Sudan" },
        { abbr: "SR", country: "Suriname" },
        { abbr: "SJ", country: "Svalbard And Jan Mayen Islands" },
        { abbr: "SZ", country: "Swaziland" },
        { abbr: "SE", country: "Sweden" },
        { abbr: "CH", country: "Switzerland" },
        { abbr: "SY", country: "Syrian Arab Republic" },
        { abbr: "TW", country: "Taiwan, Province Of China" },
        { abbr: "TJ", country: "Tajikistan" },
        { abbr: "TZ", country: "Tanzania, United Republic Of" },
        { abbr: "TH", country: "Thailand" },
        { abbr: "TG", country: "Togo" },
        { abbr: "TK", country: "Tokelau" },
        { abbr: "TO", country: "Tonga" },
        { abbr: "TT", country: "Trinidad And Tobago" },
        { abbr: "TN", country: "Tunisia" },
        { abbr: "TR", country: "Turkey" },
        { abbr: "TM", country: "Turkmenistan" },
        { abbr: "TC", country: "Turks And Caicos Islands" },
        { abbr: "TV", country: "Tuvalu" },
        { abbr: "UG", country: "Uganda" },
        { abbr: "UA", country: "Ukraine" },
        { abbr: "AE", country: "United Arab Emirates" },
        { abbr: "GB", country: "United Kingdom" },
        { abbr: "UM", country: "United States Minor Outlying Islands" },
        { abbr: "UY", country: "Uruguay" },
        { abbr: "UZ", country: "Uzbekistan" },
        { abbr: "VU", country: "Vanuatu" },
        { abbr: "VA", country: "Vatican City State (holy See" },
        { abbr: "VE", country: "Venezuela" },
        { abbr: "VN", country: "Viet Nam" },
        { abbr: "VG", country: "Virgin Islands (british" },
        { abbr: "VI", country: "Virgin Islands (u.s" },
        { abbr: "WF", country: "Wallis And Futuna Islands" },
        { abbr: "EH", country: "Western Sahara" },
        { abbr: "YE", country: "Yemen" },
        { abbr: "YU", country: "Yugoslavia" },
        { abbr: "ZR", country: "Zaire" },
        { abbr: "ZM", country: "Zambia" },
        { abbr: "ZW", country: "Zimbabwe" }
      ],
      provinces: [
        { abbr: "AB", name: "Alberta" },
        { abbr: "BC", name: "British Columbia" },
        { abbr: "MB", name: "Manitoba" },
        { abbr: "NB", name: "New Brunswick" },
        { abbr: "NL", name: "Newfoundland and Labrador" },
        { abbr: "NT", name: "Northwest Territories" },
        { abbr: "NS", name: "Nova Scotia" },
        { abbr: "NU", name: "Nunavut" },
        { abbr: "PN", name: "Ontario" },
        { abbr: "PE", name: "Prince Edward Island" },
        { abbr: "QC", name: "Quebec" },
        { abbr: "SK", name: "Saskatchewan" },
        { abbr: "YT", name: "Yukon Territory" }
      ],
      states: [
        { abbr: "AL", name: "Alabama" },
        { abbr: "AK", name: "Alaska" },
        { abbr: "AZ", name: "Arizona" },
        { abbr: "AR", name: "Arkansas" },
        { abbr: "CA", name: "California" },
        { abbr: "CO", name: "Colorado" },
        { abbr: "CT", name: "Connecticut" },
        { abbr: "DE", name: "Delaware" },
        { abbr: "DC", name: "District of Columbia" },
        { abbr: "FL", name: "Florida" },
        { abbr: "GA", name: "Georgia" },
        { abbr: "HI", name: "Hawaii" },
        { abbr: "ID", name: "Idaho" },
        { abbr: "IL", name: "Illinois" },
        { abbr: "IN", name: "Indiana" },
        { abbr: "IA", name: "Iowa" },
        { abbr: "KS", name: "Kansas" },
        { abbr: "KY", name: "Kentucky" },
        { abbr: "LA", name: "Louisiana" },
        { abbr: "ME", name: "Maine" },
        { abbr: "MD", name: "Maryland" },
        { abbr: "MA", name: "Massachusetts" },
        { abbr: "MI", name: "Michigan" },
        { abbr: "MN", name: "Minnesota" },
        { abbr: "MS", name: "Mississippi" },
        { abbr: "MO", name: "Missouri" },
        { abbr: "MT", name: "Montana" },
        { abbr: "NE", name: "Nebraska" },
        { abbr: "NV", name: "Nevada" },
        { abbr: "NH", name: "New Hampshire" },
        { abbr: "NJ", name: "New Jersey" },
        { abbr: "NM", name: "New Mexico" },
        { abbr: "NY", name: "New York" },
        { abbr: "NC", name: "North Carolina" },
        { abbr: "ND", name: "North Dakota" },
        { abbr: "OH", name: "Ohio" },
        { abbr: "OK", name: "Oklahoma" },
        { abbr: "OR", name: "Oregon" },
        { abbr: "PA", name: "Pennsylvania" },
        { abbr: "RI", name: "Rhode Island" },
        { abbr: "SC", name: "South Carolina" },
        { abbr: "SD", name: "South Dakota" },
        { abbr: "TN", name: "Tennessee" },
        { abbr: "TX", name: "Texas" },
        { abbr: "UT", name: "Utah" },
        { abbr: "VT", name: "Vermont" },
        { abbr: "VA", name: "Virginia" },
        { abbr: "WA", name: "Washington" },
        { abbr: "WV", name: "West Virginia" },
        { abbr: "WI", name: "Wisconsin" },
        { abbr: "WY", name: "Wyoming" }
      ]
    };
  }
};
</script>

<style></style>
